import { DtoExt } from '@/classes/scenario/DtoExt';
import { GridPricingFile } from '@/dto/scenario/eco/GridPricingFile';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class GridPricingFileExt extends DtoExt {
  public static fromDto(dto: GridPricingFile): GridPricingFileExt {
    return new GridPricingFileExt({
      durationYear: dto.durationYear,
      name: dto.name,
      originalContent: dto.originalContent
    });
  }

  public durationYear: number | null = 1;
  public name: string | null = 'gridMyFilePricing';
  public originalContent: string | null = null;

  constructor(options: ObjectOnly = {}) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): GridPricingFile {
    return new GridPricingFile({
      durationYear: this.durationYear,
      name: this.name,
      originalContent: this.originalContent
    });
  }

}
